<template>
    <teleport to="body">
        <Transition>
            <div v-show="leadModalIsVisible" class="uk-text-center the-modal">
                <div class="the-modal-content the-modal-content-header uk-position-relative">
                    <div class="close-the-modal uk-position-absolute uk-position-small uk-position-top-right" @click="closeLeadModal">
                        <BaseIcon color="#cdcdcd" height="35" stroke-width=".75" width="35">
                            <IconX />
                        </BaseIcon>
                    </div>
                </div>
                <div class="the-modal-content the-modal-content-body">
                    <p class="uk-h4 uk-margin-remove">Please enter email &amp; zip</p>
                    <p class="uk-text-small uk-margin-remove-top">to see prices, view wishlist, and more</p>
                    <form class="uk-form-stacked uk-text-left" novalidate @submit.prevent="submit">
                        <div class="uk-margin">
                            <label for="email">Email<span class="uk-text-danger"> *</span></label>
                            <input id="email" v-model="form.email" class="uk-input uk-form-small" name="email" type="text">
                            <span v-if="errors?.email" class="uk-text-small uk-text-danger">{{ errors.email[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <label for="zip">Zip<span class="uk-text-danger"> *</span></label>
                            <input id="zip" v-model="form.zip" class="uk-input uk-form-small" name="zip" type="text">
                            <span v-if="errors?.zip" class="uk-text-small uk-text-danger">{{ errors.zip[0] }}</span>
                        </div>
                        <div class="uk-margin">
                            <label for="catalog">
                                <input id="catalog" v-model="catalog" class="uk-checkbox" name="catalog" type="checkbox">
                                <span class="uk-margin-small-left">Please send me your beautiful catalog</span>
                            </label>
                        </div>
                        <div class="uk-flex uk-flex-right">
                            <button :disabled="processing" class="uk-button uk-button-primary">
                                <span v-show="processing" id="submit-button-spinner" uk-spinner></span>
                                <span v-show="!processing" id="submit-button-text">Submit</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Transition>
    </teleport>
</template>

<script setup>
import {reactive, ref} from 'vue';
import {storeToRefs} from "pinia";
import {useWishlistStore} from "../../stores/WishlistStore";
import BaseIcon from "../ui/BaseIcon.vue"
import IconX from "../icons/IconX.vue"
import {useModalStatusStore} from "../../stores/ModalStatusStore";

const modalStatusStore = useModalStatusStore()
const {setWishlistDataFromServer} = useWishlistStore()
const errors = ref({})
const catalog = ref(false)
const processing = ref(false)

const form = reactive({
    email: '',
    zip: ''
});

const {
    leadModalIsVisible,
} = storeToRefs(modalStatusStore)

async function submit() {
    processing.value = true
    try {
        let r = await axios
            .post('/lead/store', form)

        setWishlistDataFromServer(r.data.data)

        if (catalog.value === true) {
            modalStatusStore.showCatalogModal()
            modalStatusStore.hideLeadModal()
        } else {
            closeLeadModal()
        }
    } catch (error) {
        if (error.response.status === 422) {
            errors.value = error.response.data.data.errors
        }
        // DEBUG OUT
        //Utility.catchError(error)
    }
    processing.value = false
}

function closeLeadModal() {
    modalStatusStore.hideLeadModal()

    window.location.reload()
}
</script>

<style scoped>
.the-modal {
    position: fixed; /* Stay in place */
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.8); /* w/ opacity */
}

/* Modal Content/Box */
.the-modal-content {
    background-color: #ffffff;
    margin-left: auto;
    margin-right: auto;
    max-width: 345px;
}

.the-modal-content-header {
    margin-top: 15px;
    margin-bottom: 0;
    padding: 10px 30px 30px 30px;
}

.the-modal-content-body {
    margin-top: 0;
    margin-bottom: 0;
    padding: 20px 30px 30px 30px;
}

.close-the-modal {
    cursor: pointer;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.75s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
